import {createSlice} from "@reduxjs/toolkit";
import {setContainerDNUStatisticsSearchPageFilter} from "./actions";
import {ContainerDNUStatisticsSearchCriteria} from "@ots-frontend/ots-data";

type ContainerDNUStatisticsSearchPageState = {
    filter?: ContainerDNUStatisticsSearchCriteria
}

const INITIAL_STATE: Readonly<ContainerDNUStatisticsSearchPageState> = {
    filter: undefined,
};

const containerDNUStatisticsSearchPageSlice = createSlice({
    name: "ui/container-dnu-statistics-search-page",
    initialState: INITIAL_STATE,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(
            setContainerDNUStatisticsSearchPageFilter,
            (state, {payload}) => {
                state.filter = payload
            }
        );
    }
});

export const containerDNUStatisticsSearchPageReducer = containerDNUStatisticsSearchPageSlice.reducer;
